import React from "react";

import { StatusTag, StatusTags } from "../StatusTags";

export type ShapeStatusTagsEntry = {
  status: "draft" | "published" | "modified";
  reviewStatus: "review_requested" | null;
};

// Renders the status tag of a shape plus one tag per version. Callers decide
// which versions are worth showing; a pending review always displays as
// "in review" instead of the publish status.
export function ShapeStatusTags({
  className,
  shape,
  versions = [],
}: {
  className?: string;
  shape: ShapeStatusTagsEntry;
  versions?: (ShapeStatusTagsEntry & { version: number })[];
}) {
  return (
    <StatusTags className={className}>
      <StatusTag status={displayStatus(shape)}>{displayLabel(shape)}</StatusTag>
      {versions.map((version) => (
        <StatusTag key={version.version} status={displayStatus(version)}>
          V{version.version} {displayLabel(version)}
        </StatusTag>
      ))}
    </StatusTags>
  );
}

function displayStatus(entry: ShapeStatusTagsEntry) {
  return entry.reviewStatus ? "inReview" : entry.status;
}

function displayLabel(entry: ShapeStatusTagsEntry) {
  return entry.reviewStatus ? "in review" : entry.status;
}
